import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { EnhancementCatalogKey } from './enhancement.i18n.js';
import { ENHANCEMENT_CATALOG } from './enhancement.i18n.js';

export type EnhancementMessageId = `enhancement:${EnhancementCatalogKey}`;

const PREFIX_LENGTH = 'enhancement:'.length;

/** `t()` for the stop-gap `enhancement:` scope (see `enhancement.i18n.ts`). */
export function useEnhancementT(): { t: (id: EnhancementMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: EnhancementMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as EnhancementCatalogKey;
      const raw = ENHANCEMENT_CATALOG[locale][key] ?? ENHANCEMENT_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
